<template>
  <draggable
      class="dragAreaParent"
      tag="div"
      :list="items"
      :group="{ name: 'g1' }"
      item-key="name"
      @end="changeParent"
      disabled="disabled"
  >

    <template #item="{ element }">
      <div>
            <div class="pl-0 p-3 text-2xl group flex" :data-debug-parent-order="element.parent.order" :data-debug-parent-id="element.parent.id">
              <img :src="'/img/' + element.parent.image_gloss" class="flex-none h-8 w-8 mr-4">
              <span class="text-gray-900 text-xl font-semibold leading-[30px]">{{ element.parent.title }}</span>
            </div>
            <question-nested-draggable-item :items="element.items" :question-set-id="questionSetId" @save-change-item="changeParent"/>
      </div>
    </template>

  </draggable>

</template>

<script>
import draggable from "vuedraggable";
import QuestionNestedDraggableItem from "./QuestionNestedDraggableItemComponent.vue";
import { initFlowbite } from 'flowbite'

export default {
  name: "QuestionNestedDraggableParentComponent",

  props: {
    items: {
      required: true,
      type: Array
    },
    questionSetId: {
      required: true,
      type: Number,
    }
  },
  components: {
    draggable,
    QuestionNestedDraggableItem,
  },
  mounted() {
    initFlowbite();
  },
  methods: {
    changeParent() {
        this.$emit('save-change-parent');
    },
  },
};
</script>